<header class="header">
  <div class="container">
    <div class="row">
      <nav class="col navbar navbar-expand-xl navbar-light">
        <div
          class="logo navbar-brand order-1 order-xl-0 order-xl-0 flex-grow-1 flex-xl-grow-0 text-center"
        >
          <a routerLink="/" tabIndex="-1">
            <img
              class="logo-image"
              height="32"
              src="/assets/img/redesign/upskill_logo.svg"
            />
          </a>
        </div>
        <!-- Hamburger menu -->
        <button
          class="navbar-toggler border-0"
          type="button"
          data-toggle="collapse"
          data-target="#navbarNavAltMarkup"
          aria-controls="navbarNavAltMarkup"
          aria-expanded="false"
          aria-label="Toggle navigation"
          (click)="openSidenav()"
        >
          <img src="/assets/img/redesign/menu.svg" />
        </button>
        <!-- Transparent bg covering page -->
        <div
          class="bg-click"
          [ngClass]="{ 'bg-gray': sidenavOpen() }"
          (click)="closeSidenav()"
        ></div>
        <!-- Menu items -->
        <div
          class="collapse navbar-collapse sidenav show outer-tabs"
          id="navbarNavAltMarkup"
          [ngClass]="{ menu: sidenavOpen() }"
        >
          <!-- Close button -->
          <button class="closebtn d-xl-none" (click)="closeSidenav()">
            <i class="close-icon"></i>
          </button>

          <div class="tabs">
            <a
              class="header-item nav-item"
              id="nav-item-home"
              (click)="closeSidenav()"
              [ngClass]="{ active: activeNavItem() == navItemEnum.Home }"
              routerLink="/"
            >
              Home
            </a>
            <a
              class="header-item nav-item"
              (click)="closeSidenav()"
              id="nav-item-events"
              [ngClass]="{ active: activeNavItem() == navItemEnum.Events }"
              routerLink="/events/event-list"
            >
              Events
            </a>
            <a
              class="header-item nav-item"
              (click)="closeSidenav()"
              id="nav-item-communities"
              [ngClass]="{ active: activeNavItem() == navItemEnum.Communities }"
              routerLink="/communities"
            >
              Communities
            </a>
            <a
              class="header-item nav-item"
              (click)="closeSidenav()"
              id="nav-item-network"
              [ngClass]="{ active: activeNavItem() == navItemEnum.Networks }"
              routerLink="/networks"
            >
              Networks
            </a>
            @if (mayManage()) {
            <a
              class="header-item nav-item"
              (click)="closeSidenav()"
              id="nav-item-manage"
              [ngClass]="{ active: activeNavItem() == navItemEnum.Manage }"
              routerLink="/manage"
            >
              Manage
            </a>
            } @if (hasAdminAccess()) {
            <a
              class="header-item d-xl-none nav-item"
              (click)="closeSidenav()"
              routerLink="/admin-dashboard"
              [ngClass]="{ active: activeNavItem() == navItemEnum.Manage }"
              >Admin dashboard</a
            >
            } @if (isLoggedIn()) {
            <a
              class="header-item d-xl-none nav-item"
              routerLink="/my-account"
              (click)="closeSidenav()"
              routerLinkActive="active"
              >My account</a
            >
            }
            <div class="login-div">
              @if (isLoggedIn()) {
              <button
                class="header-item d-xl-none pointer nav-item"
                (click)="logout()"
                id="nav-item-login"
              >
                <i class="logout"></i>Log out
              </button>
              } @else {
              <button
                class="header-item d-xl-none pointer nav-item"
                (click)="redirectToLogin()"
                id="nav-item-login"
              >
                <i class="login"></i>Log in
              </button>
              }
            </div>
          </div>
        </div>
        <div class="login d-none d-xl-flex">
          @if (isLoggedIn()) {
          <div class="dropdown" dropdown>
            <button
              class="dropdown dropdownToggler d-flex align-items-center bg-transparent border-0"
              id="nav-item-username"
              (click)="turnArrow()"
              dropdownToggle
              #dropdown
            >
              <profile-image
                class="profile-image"
                [imageUrl]="userInfo()?.imageURL"
                [isProfile]="true"
              >
              </profile-image>
              <span class="mx-2">
                {{ firebaseUserInfo()?.displayName | displayName }}
              </span>
              <span>
                <img
                  class="arrow"
                  height="24px"
                  width="24px"
                  id="nav-item-isloggedin-dropdown"
                  src="assets/img/redesign/chevron-down.svg"
                />
              </span>
            </button>
            <div
              class="dropdown-menu"
              aria-labelledby="dropdownMenuLink"
              *dropdownMenu
            >
              <a
                class="dropdown-item"
                routerLink="/my-account"
                routerLinkActive="active"
              >
                My account
              </a>
              @if (hasAdminAccess()) {
              <a
                class="dropdown-item"
                (click)="closeSidenav()"
                routerLinkActive="active"
                routerLink="/admin-dashboard"
              >
                Admin dashboard
              </a>
              }
              <button
                type="button"
                class="dropdown-item pointer"
                (click)="logout()"
              >
                Log Out
              </button>
            </div>
          </div>
          } @else {
          <button
            class="dropdown dropdownToggler d-flex align-items-center bg-transparent border-0"
            id="nav-item-login"
            (click)="redirectToLogin()"
          >
            <profile-image class="profile-image"></profile-image>
            <span class="mx-2">Log In</span>
          </button>
          }
        </div>
      </nav>
    </div>
  </div>
</header>
